import TitleBlock from '@anm/components/TitleBlock';
import { VideoTemplatesPageContext } from '@anm/contexts/VideoTemplatesPageContext';
import pages, { TemplatePage } from '@anm/data/video-templates/pages';
import capitalize from '@anm/helpers/string/capitalize';
import { useContext, FC } from 'react';

import ContainerWrapper, { Text } from './Wrapper';

const FooterDescription: FC = () => {
  const { pageName } = useContext(VideoTemplatesPageContext);
  const { footer } = pages[pageName] as TemplatePage;

  const { category, type = 'video' } = footer;

  const categorySlug = category ? `${category} ` : '';
  const title = `Free ${capitalize(categorySlug)}${capitalize(type)} Templates Collection`;

  const descriptions = footer.description.split('<br>');
  const description = descriptions[0];

  const otherParagraphs = descriptions.slice(1);

  return (
    <ContainerWrapper size={740}>
      <TitleBlock level={4} color="black" {...{ title, description }} />
      {otherParagraphs?.map(text => (
        <Text key={text}>{text}</Text>
      ))}
    </ContainerWrapper>
  );
};

export default FooterDescription;
